import { Controller } from 'stimulus';
import CableReady from 'cable_ready';
import consumer from '../channels/consumer';

class PDAssignmentController extends Controller {
  resetAssignments(event) {
    const confirmationText = `Resetting assignments will remove the assessment
      from the learner's account, your program director dashboard, and all group
      reports. If you need a copy of assessment performance, please download the
      Cohort Asessment Report before proceeding. The assessments will become
      available to assign again. This action cannot be undone. Would you like to
      continue?
    `.replace(/\s+/g, ' ');

    const result = confirm(confirmationText);
    const jwt = event.target.dataset.jwt;

    if (result) {
      const examInputs = document.getElementsByName(
        'exam_ids[]'
      ) as NodeListOf<HTMLInputElement>;

      document.getElementsByClassName('flash')[0].innerHTML =
        "<p class = 'notice'>Resetting Assignments.</p>";
      const examIds = Array.from(examInputs)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);

      const body = { examIds: examIds };
      consumer.subscriptions.create(location.pathname, {
        received(data) {
          if (data.cableReady) CableReady.perform(data.operations);
        },
      });

      fetch('/api/v3/assignment_resets?broadcast_id=' + location.pathname, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }).then(
        () =>
          (document.getElementsByClassName('flash')[0].innerHTML =
            "<p class = 'notice'>Resetting Assignments.  The page will refresh when it is complete</p>")
      );
    }
  }
}

export default PDAssignmentController;
